import { handleResponse } from 'helper/handleResponse';
import { authHeader } from 'helper/authHeader';
import { baseUrl } from 'helper/ApiCall';

export const emailTemplatesService = {
	getEmailTemplates,
	getMailTypes,
	storeEmailTemplates,
	editEmailTemplates,
	deleteEmailTemplates,
	getEmailTemplate,
    sendContactEmail
}

function getEmailTemplates(){
	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(baseUrl+'emailTemplates', requestOptions).then(handleResponse);
}

function getMailTypes(){
	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(baseUrl+'emailTypes', requestOptions).then(handleResponse);
}

function storeEmailTemplates(data){
	 const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(baseUrl+'emailTemplates', requestOptions)
        .then(handleResponse)
        .then(emailTemplate => {
            return emailTemplate;
        });
}

function editEmailTemplates(data, id){
	 const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(baseUrl+'emailTemplates/'+id, requestOptions)
        .then(handleResponse)
        .then(emailTemplate => {
            return emailTemplate;
        });
}

function deleteEmailTemplates(id){
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };


    return fetch(baseUrl+'emailTemplates/'+id, requestOptions).then(handleResponse);
}

function getEmailTemplate(typeName){
	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(baseUrl+'emailTemplate/'+typeName, requestOptions).then(handleResponse);
}
function sendContactEmail(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(baseUrl+'sendContactEmail', requestOptions)
    .then(handleResponse)
    .then(emailTemplate => {
        return emailTemplate;
    });
}


// WEBPACK FOOTER //
// ./src/services/emailTemplates.js